import React from 'react';

interface BaseIntegrationFormProps {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

/**
 * Componente base para formulários de integração
 * Envolve os campos específicos de cada integração
 */
export function BaseIntegrationForm({ children, onSubmit }: BaseIntegrationFormProps) {
  return (
    <form id="integration-form" onSubmit={onSubmit} className="space-y-5">
      {children}
    </form>
  );
}
